import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, LogOut } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const authed = user && user !== false;

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-cream/80 backdrop-blur-md border-b border-border" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <span className="w-2.5 h-2.5 rounded-full bg-clay group-hover:scale-125 transition-transform duration-300" />
          <span className="font-serif text-2xl tracking-tight text-forest">Zenith</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm text-muted-foreground">
          <Link to="/#services" className="hover:text-forest transition-colors duration-300" data-testid="nav-services">Services</Link>
          <Link to="/#approach" className="hover:text-forest transition-colors duration-300" data-testid="nav-approach">Approach</Link>
          <Link to="/#voices" className="hover:text-forest transition-colors duration-300" data-testid="nav-voices">Voices</Link>
        </nav>

        <div className="flex items-center gap-3">
          {authed ? (
            <>
              <Button variant="ghost" onClick={() => navigate("/dashboard")} className="text-forest hover:bg-surfacealt gap-2" data-testid="nav-dashboard-btn">
                <LayoutDashboard className="w-4 h-4" /> Dashboard
              </Button>
              <Button variant="ghost" onClick={logout} className="text-muted-foreground hover:text-forest gap-2" data-testid="nav-logout-btn">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <Button variant="ghost" onClick={() => navigate("/login")} className="text-forest hover:bg-surfacealt" data-testid="nav-login-btn">
              Sign in
            </Button>
          )}
          <Button onClick={() => navigate("/book")} className="rounded-none bg-forest hover:bg-forest-dark text-cream px-6 transition-colors duration-300" data-testid="nav-book-btn">
            Book a session
          </Button>
        </div>
      </div>
    </header>
  );
}
